import React from 'react';
import {ScrollView, StyleSheet, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {pine} from '/theme/color/primary.color';

import Icon from '../Icon';

import NavigationListingStory from './Navigation';
import RankListingStory from './Rank';
import SocialListingStory from './Social';
import SystemListingStory from './System';

const overrideStyle = StyleSheet.create({
  icon: {
    fontSize: 48,
    color: pine,
  },
});

storiesOf('base', module).add('Icon', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Icon</Heading>
        <Spacer size={16} />
        <Text>
          Icons are loaded as an icon font into the application. They can be
          rendered using the <Code>{'<Icon />'}</Code> component. The icon to
          render is specified via the <Code>{'name'}</Code> prop.
        </Text>
        <Spacer size={24} />
        <FlexView expand={false}>
          <Icon name="dashboard" />
          <Spacer size={6} />
          <Code>{'name="dashboard"'}</Code>
        </FlexView>
        <Spacer size={16} />
        <Text>
          By default the icon has <Code>fontSize: 24</Code>
          and <Code>color: '#919EAB'</Code> (which is <Code>onyxLightest</Code>
          ). These and other styles for the icon can be overridden by passing in
          a <Code>style</Code> prop:
        </Text>
        <Spacer size={24} />
        <FlexView expand={false}>
          <Icon name="dashboard" style={overrideStyle.icon} />
          <Spacer size={6} />
          <Code>{'name="dashboard"'}</Code>
          <Code>{'style={{fontSize: 48, color: pine}}'}</Code>
        </FlexView>
        <Spacer size={24} />
        <RankListingStory />
        <Spacer size={24} />
        <SocialListingStory />
        <Spacer size={24} />
        <NavigationListingStory />
        <Spacer size={24} />
        <SystemListingStory />
      </FlexView>
    </Spacing>
  </ScrollView>
));
